import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import useFlowQuestions from '../../../../../hooks/useFlowQuestions';
import {
  FlowsQuestion,
  FlowsQuestionGroup,
} from '../../../../../types/FlowsTypes';
import { filterForConditions } from '../../../../../utils/flowsQuestionnaireUtils';

const useDuplicateGroups = (
  question: FlowsQuestion,
  currentIndex?: number,
): FlowsQuestionGroup[] => {
  const duplicateGroups = useFlowsSelector(
    (state) => state.flows.metaData.duplicateQuestionMapping?.[question.id],
  );

  const initialQuestionnaire = useFlowsSelector(
    (state) => state.flows.initialQuestionnaire,
  );
  const answers = useFlowsSelector((state) => state.flows.answers);
  const questions = useFlowQuestions();

  const filteredQuestionnaire = filterForConditions(
    initialQuestionnaire,
    answers,
    questions,
    currentIndex,
  );

  const possibleGroups = filteredQuestionnaire.groups.filter(
    ({ tag }) => tag.toLowerCase() === question.tag.toLowerCase(),
  );

  return (
    possibleGroups
      ?.filter(({ id }) => duplicateGroups?.includes(id))
      .map((group) => ({
        ...group,
        index: currentIndex,

        questions: group.questions.map((question) => ({
          ...question,
          index: currentIndex,
        })),
      })) || []
  );
};

export default useDuplicateGroups;
